import { CSSTransition } from "react-transition-group";
import React from "react";
const BackDrop = ({ show, children, onEntered }) => {
    return (
        <CSSTransition in={show} timeout={500} onEntered={onEntered} classNames="fade" unmountOnExit>
            <div className="fixed flex items-center justify-center z-50 min-w-full max-w-full min-h-screen top-0 left-0 bg-gray-700 bg-opacity-50 backdrop-filter backdrop-blur-sm">
                {children}
            </div>
        </CSSTransition>
    )
};

export default BackDrop;